import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const DocumentWithCheckOutline = createIcon({
  displayName: 'DocumentWithCheckOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 14h8"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 17h8"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11.5 10l-1.5-1.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14 7.5l-2.5 2.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 21h-14c-1.105 0-2-.895-2-2v-14c0-1.105.895-2 2-2h14c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2Z"
        ></path>
      </g>
    </>
  ),
})

const DocumentWithCheckTwoTone = createIcon({
  displayName: 'DocumentWithCheckTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 14h8"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 17h8"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11.5 10l-1.5-1.5"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14 7.5l-2.5 2.5"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 21h-14c-1.105 0-2-.895-2-2v-14c0-1.105.895-2 2-2h14c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2Z"
        ></Box>
      </Box>
    </>
  ),
})

const DocumentWithCheck: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={DocumentWithCheckTwoTone} {...props} />
  return <CustomIcon as={DocumentWithCheckOutline} {...props} />
}

export default memo(DocumentWithCheck)
